import { ApiProvider, AssistantMessage, ToolMessage, UserMessage } from '../types'

// Model selection uses current message mentions first, then checks
// previous messages in reverse order, and falls back to defaults
export function getModelIdForMessage({
  mentions,
  isExistingChat,
  conversationId,
  allMessages,
  defaultModel,
  useAdvancedReasoning,
  modelChoice,
}: {
  mentions: UserMessage['mentions']
  isExistingChat: boolean
  conversationId: string
  allMessages: Record<string, (UserMessage | AssistantMessage | ToolMessage)[]>
  defaultModel?: string
  useAdvancedReasoning?: boolean
  /** Without it the turn names no model and the server picks. */
  modelChoice: boolean
}): string | undefined {
  if (!modelChoice) return undefined

  const currentModelMention = mentions.find((mention) => mention.type === 'model')
  if (currentModelMention) return currentModelMention.value

  if (isExistingChat && allMessages[conversationId]) {
    const userMessages = allMessages[conversationId].filter((msg): msg is UserMessage => msg.role === 'user')

    for (let i = userMessages.length - 1; i >= 0; i--) {
      const modelMention = userMessages[i].mentions?.find((mention) => mention.type === 'model')
      if (modelMention) {
        return modelMention.value
      }
    }
  }

  if (defaultModel) {
    return defaultModel
  }

  // @TODO don't hardcode this, reference actual model list
  if (useAdvancedReasoning) {
    return '13f2796e-e91d-49ca-939b-31f8d356a351'
  }

  return undefined
}

export const PROVIDER_MAPPING: Record<ApiProvider, string[]> = {
  openai: ['OPENAI', 'AZURE-OPENAI', 'AZURE-OPENAI-EASTUS2'],
  anthropic: ['ANTHROPIC'],
  google: ['GOOGLE-GEMINI'],
}

export const isLocalUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url)
    const hostname = urlObj.hostname.toLowerCase()
    return (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname.startsWith('192.168.') ||
      hostname.startsWith('10.') ||
      hostname.startsWith('172.16.') ||
      hostname.startsWith('172.17.') ||
      hostname.startsWith('172.18.') ||
      hostname.startsWith('172.19.') ||
      hostname.startsWith('172.20.') ||
      hostname.startsWith('172.21.') ||
      hostname.startsWith('172.22.') ||
      hostname.startsWith('172.23.') ||
      hostname.startsWith('172.24.') ||
      hostname.startsWith('172.25.') ||
      hostname.startsWith('172.26.') ||
      hostname.startsWith('172.27.') ||
      hostname.startsWith('172.28.') ||
      hostname.startsWith('172.29.') ||
      hostname.startsWith('172.30.') ||
      hostname.startsWith('172.31.') ||
      hostname === '[::1]'
    )
  } catch (e) {
    // If URL parsing fails, return false
    return false
  }
}

// Thinking-markup extraction lives in the engine (pure TS, no barrel imports);
// re-exported here for the legacy call sites.
export { extractThinkingContent, hasPartialThinkingContent } from '../engine/thinking-markup'
